import { Box, Button } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import SearchBar from '../../__legacy__/components/platform/new-explore/components/SearchBar'
import {
  SearchContext,
  useSearch
} from '../../__legacy__/components/platform/new-explore/hooks/useSearch'
import { MintSoundModal } from '../../__legacy__/components/studio/mint/upload-sound-modal/MintSoundModal'
import { useTreeState } from '../../__legacy__/stores/Root'
import { ArpTable } from '../arp-table'
import { TableRow } from '../arp-tablerow'
import { Page } from './primitives'

const SearchSection: FC = () => {
  const [search, setSearch] = useSearch()
  return (
    <Page.SearchContainer>
      <SearchBar css={{ flex: 1 }} value={search} onChange={(evt) => setSearch(evt.target.value)} />
      <Box css={{ padding: '16px' }}>or</Box>
      <MintSoundModal trigger={<Button variant="primary">Upload your own</Button>} />
    </Page.SearchContainer>
  )
}

const { Filters, Headers, DEFAULT_SOUNDS_FILTERS } = ArpTable

const SoundsTable: FC = observer(() => {
  const { globalPlayer } = useTreeState()
  const currentId = globalPlayer.arpMediaIndex
  return (
    <ArpTable.Root defaultFilters={DEFAULT_SOUNDS_FILTERS}>
      <Filters.Root tags>
        <Filters.Instrument />
        <Filters.Key />
        <Filters.Type />
      </Filters.Root>
      <Headers.Root>
        <Headers.Title />
        <Headers.Tags />
        <Headers.DateMinted />
        <Headers.Remixes />
        <Headers.Favorite />
        <Headers.Duration />
      </Headers.Root>
      <ArpTable.Table>
        {(media) => (
          <TableRow.Root media={media} key={media.id} active={currentId === media.id}>
            <TableRow.Main />
            <TableRow.Tags />
            <TableRow.DateMinted />
            <TableRow.Remixes />
            <TableRow.Favorite />
            <TableRow.Duration />
            <TableRow.Actions />
          </TableRow.Root>
        )}
      </ArpTable.Table>
    </ArpTable.Root>
  )
})

export const Sounds: FC = () => {
  const search = useState<string>()
  return (
    <SearchContext.Provider value={search}>
      <Page.Root>
        <Page.Flare type="one" />
        <Page.Flare type="two" />
        <Page.Header>
          <Page.Title>Browse Sounds</Page.Title>
          <Page.Subtitle>Discover our endless library of user generated sounds</Page.Subtitle>
          <SearchSection />
        </Page.Header>
        <Page.Divider />
        <Page.Content>
          <SoundsTable />
        </Page.Content>
      </Page.Root>
    </SearchContext.Provider>
  )
}
